import { MapPin, Loader2, Check, Radio } from "lucide-react";
import { useLiveLocation } from "@/components/trip/useLiveLocation";

export function LiveLocationShare({ bookingId }) {
  const { sharing, last, error, start, stop } = useLiveLocation(bookingId);

  return (
    <div className="rounded-2xl border border-sky-200 bg-sky-50 p-4" data-testid="live-location-share">
      <div className="flex items-start gap-3">
        <span className="mt-0.5 grid h-9 w-9 shrink-0 place-items-center rounded-full bg-sky-500 text-white">
          {sharing ? <Radio className="h-4 w-4 animate-pulse" /> : <MapPin className="h-4 w-4" />}
        </span>
        <div className="min-w-0 flex-1">
          <p className="text-sm font-semibold text-sky-900">Live trip location</p>
          <p className="mt-0.5 text-xs text-sky-800">
            {sharing ? "Sharing your precise location with Hoorecars support for this trip." : "Share your location so our team can assist you faster during the trip."}
          </p>
          {last && <p className="mt-1 flex items-center gap-1 text-xs text-emerald-700" data-testid="live-location-ok"><Check className="h-3 w-3" />Updated {last.toLocaleTimeString("en-IN")}</p>}
          {error && <p className="mt-1 text-xs text-rose-600" data-testid="live-location-error">{error}</p>}
        </div>
        <button onClick={sharing ? stop : start} data-testid="live-location-toggle"
          className={`shrink-0 rounded-full px-4 py-2 text-sm font-semibold ${sharing ? "bg-white text-sky-700 ring-1 ring-sky-300" : "bg-sky-600 text-white"}`}>
          {sharing ? "Stop" : "Share"}
        </button>
      </div>
      {sharing && !last && <p className="mt-2 flex items-center gap-1 text-xs text-sky-700"><Loader2 className="h-3 w-3 animate-spin" />Getting your location…</p>}
    </div>
  );
}
